const NCB_CONFIG = {
  instance: '53734_creditsonar',
  secretKey: '4a99af87b5740b7456efc98adf63dac9c1af784d1c592412a238207e20e1',
  authUrl: 'https://app.nocodebackend.com/api/user-auth',
  dataUrl: 'https://app.nocodebackend.com/api/data',
};

export async function authFetch(path, options = {}) {
  return fetch(`${NCB_CONFIG.authUrl}/${path}`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
      'X-Database-Instance': NCB_CONFIG.instance,
      ...options.headers,
    },
    ...options,
  });
}

export async function writeFetch(path, options = {}) {
  const separator = path.includes('?') ? '&' : '?';
  const url = `${NCB_CONFIG.dataUrl}/${path}${separator}Instance=${NCB_CONFIG.instance}`;

  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${NCB_CONFIG.secretKey}`,
      'X-Database-Instance': NCB_CONFIG.instance,
      ...options.headers,
    },
    ...options,
  });
}

// USER PROFILE MANAGEMENT
export async function getUserProfile(userId) {
  const res = await writeFetch(`read/user_profiles_1740001000?owner_id=${userId}`);
  const data = await res.json();
  return data.data?.[0] || null;
}

export async function createUserProfile(userId, plan = 'basic') {
  return writeFetch('create/user_profiles_1740001000', {
    method: 'POST',
    body: JSON.stringify({
      id: crypto.randomUUID(),
      owner_id: userId,
      plan: plan,
      created_at: new Date().toISOString()
    })
  });
}

export async function signIn(email, password) {
  const res = await authFetch('sign-in/email', {
    method: 'POST',
    body: JSON.stringify({ email, password })
  });
  const data = await res.json();
  if (data.token && data.user) {
    const profile = await getUserProfile(data.user.id);
    const userWithPlan = { ...data.user, plan: profile?.plan || 'basic' };
    localStorage.setItem('ncb_token', data.token);
    localStorage.setItem('ncb_user', JSON.stringify(userWithPlan));
    return userWithPlan;
  }
  throw new Error(data.message || 'Login failed');
}

export async function signUp(email, password, name, plan = 'basic') {
  const res = await authFetch('sign-up/email', {
    method: 'POST',
    body: JSON.stringify({ email, password, name })
  });
  const data = await res.json();
  if (data.token && data.user) {
    // Create the profile with the specific plan (pro or basic)
    await createUserProfile(data.user.id, plan);
    const userWithPlan = { ...data.user, plan };
    localStorage.setItem('ncb_token', data.token);
    localStorage.setItem('ncb_user', JSON.stringify(userWithPlan));
    return userWithPlan;
  }
  throw new Error(data.message || 'Signup failed');
}

export function getSession() {
  const stored = localStorage.getItem('ncb_user');
  return stored ? JSON.parse(stored) : null;
}

export function signOut() {
  localStorage.removeItem('ncb_token');
  localStorage.removeItem('ncb_user');
}

// OSINT Saved Searches
export async function saveSearch(user, companyName, location, markdownReport) {
  return writeFetch('create/saved_searches_1716001122', {
    method: 'POST',
    body: JSON.stringify({
      customer_name: companyName,
      country: location || '',
      markdown_report: markdownReport,
      owner_id: user.id,
      created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
    })
  });
}

export async function fetchSavedSearches(user) {
  const res = await writeFetch(
    `read/saved_searches_1716001122?owner_id=${user.id}&sort=created_at&order=desc&limit=50`
  );
  const data = await res.json();
  return data.data || [];
}

export async function deleteSavedSearch(id) {
  return writeFetch(`delete/saved_searches_1716001122/${id}`, {
    method: 'DELETE',
  });
}